module.exports = __webpack_public_path__ + "static/media/poll.85e2312e.png";